// Track if main add-to-cart button was clicked
let mainProductClicked = false;

// Wait for DOM to load before attaching listener
document.addEventListener('DOMContentLoaded', () => {
  const mainButton = document.querySelector('.add-to-cart-single-productpage .button.button--primary');
  if (mainButton) {
    mainButton.addEventListener('click', () => {
      mainProductClicked = true;
      console.log('✅ Main product clicked');
    });
  }
});

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        console.log(this.querySelector('[type="submit"]'));

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        try {
          const response = await fetch(`${routes.cart_add_url}`, config).then(res => res.json());

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });

            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }

            this.error = true;
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                }, 200);
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            if (response.sections && typeof response.sections === 'object') {
              this.cart.renderContents(response);
            } else {
              console.warn('⚠️ Unexpected cart response format. Skipping render.');
            }
          }

          if (mainProductClicked) {
            await this.handleUpsellsAndComplements();
            mainProductClicked = false;
          }

        } catch (error) {
          console.error('🛑 Add to cart failed:', error);
          this.handleErrorMessage("There was an issue adding the product. Please try again.");
          this.error = true;
        } finally {
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading__spinner').classList.add('hidden');

          if (!this.error) this.submitButton.removeAttribute('aria-disabled');


          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
        }
      }

      async handleUpsellsAndComplements() {
        // Handle optional upgrade click
        if (window.jQuery && $(".strength-upgrade-wrapper").length && !$(".strength-upgrade-wrapper").hasClass("unchecked")) {
          const upgradeBtn = $(".upgrade-atc");
          if (upgradeBtn.length) {
            upgradeBtn.click();
            console.log("✅ Upgrade added");
            await new Promise(resolve => setTimeout(resolve, 800));
          }
        }

        // Handle complementary products
        const complementaryButtons = document.querySelectorAll(
          '[class^="complementary-prod"] .card--horizontal__quick-add'
        );
        for (let i = 0; i < complementaryButtons.length; i++) {
          const btn = complementaryButtons[i];
          if (btn) {
            btn.click();
            console.log(`✅ Complementary product ${i + 1} clicked`);
            await new Promise(resolve => setTimeout(resolve, 800));
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
